/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { makeStyles } from '@material-ui/core/styles';
import { object, bool, string } from 'prop-types';
import React, { useEffect } from 'react';
import { compose } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import ReactMarkdown from 'react-markdown';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getCalendarMessageSaleForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';

const useStyles = makeStyles(() => ({
    holidayBannerRoot: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '12px 10px',
        margin: '10px 0px ',
        borderRadius: '6px',
        width: '95%',
        height: '50px',
        '@media(min-width: 600px)': {
            margin: '10px 50px 0px',
            width: '81%',
            height: '50px',
        },
    },
    weatherBannerRoot: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '12px 5px',
        margin: '10px 0px',
        borderRadius: '6px',
        width: '350px',
        height: '71px',
        '@media(min-width: 600px)': {
            margin: '10px 50px',
            width: '490px',
            height: '83px',
        },
        '@media(max-width: 400px)': {
            margin: '10px -10px',
        },
        '@media(max-width: 360px)': {
            margin: '10px -20px',
        },
    },
    heading: {
        fontSize: '14px',
        fontWeight: 700,
        lineHeight: '20px',

        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        color: '#000000',
        '& span': {
            display: 'flex',
        },
    },
    messageBody: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '20px',
        color: '#000000',
        display: 'flex',
    },
    copy: {
        textAlign: 'center',
        color: '#000000',
        '& p': {
            margin: 0,
            width: '370px',
            '@media(max-width: 531px)': {
                width: '300px',
            },
            '@media(max-width: 431px)': {
                width: '250px',
            },
            '@media(max-width: 375px)': {
                fontSize: '12px',
                width: '200px',
            },
            '@media(max-width: 321px)': {
                fontSize: '12px',
                width: '180px',
            },
        },
    },
    iconLeft: {
        marginRight: '6px',
    },
    iconRight: {
        marginLeft: '6px',
    },
    holidayIconLeft: {
        margin: 'auto',
        paddingRight: '8px',
    },
    holidayIconRight: {
        margin: 'auto',
        paddingLeft: '8px',
    },
}));

const CalendarBanner = ({
    data, weatherBanner, deliveryType, flags, calendarBannerIcon,
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    // CONTROL OR VARIANT(TEST) VALUE for Calendar Messaging Sales Force Test
    const calendarBannerMessageABTest = useSelector(getCalendarMessageSaleForceABTest);
    const isCalendarBannerMessageUserGroup = calendarBannerMessageABTest?.campaign?.campaignResponses?.[0]?.userGroup  === 'Default';

    useEffect(() => {
        if (typeof isCalendarBannerMessageUserGroup !== 'undefined' && typeof window !== 'undefined' && isCalendarBannerMessageUserGroup) {
            // GA tracking
            const eventParam = {
                eventCategory: 'Experiment',
                eventAction: 'Calendar Banner Message',
                eventLabel: isCalendarBannerMessageUserGroup ? 'Variant' : 'Control',
                feature_detail: isCalendarBannerMessageUserGroup ? 'Variant' : 'Control',
                feature_element: 'Calendar Banner Message',
                feature_category: 'Experiment',
            };
            dispatch(trackEvent(eventParam));
        }
    }, [isCalendarBannerMessageUserGroup]);

    const holidayBannerTest = flags['experiment-calendar-banner'];
    let bannerTest = {};
    if (!weatherBanner && holidayBannerTest?.type === 'variant') {
        bannerTest = holidayBannerTest;
    } else if (!weatherBanner && holidayBannerTest?.type !== 'variant') {
        return <></>;
    }

    // there is css implemented(maybe in CS) conflicting with div, using section for now.
    return (
        <>
            {!isCalendarBannerMessageUserGroup || !(isCalendarBannerMessageUserGroup && bannerTest?.icon && bannerTest?.copy)
                ? (
                    <section style={{ background: data?.banner?.background_color?.color || data?.banner?.background?.color  || 'transparent' }} className={weatherBanner ? classes.weatherBannerRoot : classes.holidayBannerRoot}>
                        {weatherBanner && data?.title && (
                            <section className={classes.heading}>
                                <span className={classes.iconLeft}>
                                    <img src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blta7646be5544c7f49/63c15a145775627a4a46bbfd/weatherIcon.svg" alt="weather_banner_left" />
                                </span>
                                {data?.title}

                                <span className={classes.iconRight}>
                                    <img src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blta7646be5544c7f49/63c15a145775627a4a46bbfd/weatherIcon.svg" alt="weather_banner_right" />
                                </span>
                            </section>
                        )}
                        <section className={classes.messageBody}>
                            <span className={classes.holidayIconLeft}>
                                <img src={calendarBannerIcon} alt="holiday_banner_left" />
                            </span>
                            <ReactMarkdown className={classes.copy} source={data?.banner?.copy} escapeHtml={false} />
                            <span className={classes.holidayIconRight}>
                                <img src={calendarBannerIcon} alt="holiday_banner_right" />
                            </span>
                        </section>
                    </section>
                ) : ''}
        </>
    );
};

CalendarBanner.propTypes = {
    data: object,
    weatherBanner: bool,
    deliveryType: string,
    flags: object,
    calendarBannerIcon: string,

};

CalendarBanner.defaultProps = {
    data: null,
    weatherBanner: false,
    deliveryType: '',
    flags: {},
    calendarBannerIcon: '',
};

export default CalendarBanner;
